import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchAnnotations = ({ fileId, offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: 'annotations',
        params: {
            file_id: fileId,
            offset,
            limit
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const createAnnotation = ({ type, file_id, geometry, timestamp, text }) => {
    return AjaxService({
        method: 'post',
        url: 'annotations',
        data: {
            type,
            file_id,
            geometry,
            timestamp,
            text
        }
    })
    .then(response => response.data?.annotation)
    .catch(handleServerError);
}

export const fetchAnnotation = annotationId => {
    return AjaxService({
        method: 'get',
        url: `annotations/${annotationId}`
    })
    .then(response => validateResponse(response, 'id').data)
    .catch(handleServerError);
}

export const updateAnnotation = (annotationId, { geometry, timestamp }) => {
    return AjaxService({
        method: 'put',
        url: `annotations/${annotationId}`,
        data: {
            geometry,
            timestamp
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeAnnotation = annotationId => {
    return AjaxService({
        method: 'delete',
        url: `annotations/${annotationId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}
